import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetOrderTextHistoryQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
}>;


export type GetOrderTextHistoryQuery = { __typename?: 'Query', orderTextHistory: { __typename?: 'OrderTextHistoryData', texts: Array<{ __typename?: 'OrderTextHistoryEntryData', sentAt: Types.TDateISO, kind: Types.CustomerDeliveryKind, body: string, contactName: string, phoneLastFour: string, status: Types.OrderTextStatus, reason?: Types.TextNotDeliveredReason | null }>, emailsInsteadOfTexts: Array<{ __typename?: 'OrderTextFallbackEmailData', kind: Types.CustomerDeliveryKind, sentAt: Types.TDateISO, sendGridMessageId?: string | null }> } };


export const GetOrderTextHistoryDocument = new TypedDocumentString(`
    query GetOrderTextHistory($orderId: String!) {
  orderTextHistory(orderId: $orderId) {
    texts {
      sentAt
      kind
      body
      contactName
      phoneLastFour
      status
      reason
    }
    emailsInsteadOfTexts {
      kind
      sentAt
      sendGridMessageId
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetOrderTextHistory: build.query<GetOrderTextHistoryQuery, GetOrderTextHistoryQueryVariables>({
      query: (variables) => ({ document: GetOrderTextHistoryDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetOrderTextHistoryQuery, useLazyGetOrderTextHistoryQuery } = injectedRtkApi;
